import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/useAuth";
import { apiGet, getApiErrorMessage } from "@/api";
import { tokenQuery } from "./query-options";

export interface ReferralItem {
  referredUserId: string;
  createdAt: string;
  hasActivePaidSubscription: boolean;
}

export interface ReferralsData {
  referralLink: string | null;
  referrals: ReferralItem[];
  activePayingCount: number;
  discountPercent: number;
}

export function referralsQueryOptions(token: string | null) {
  return tokenQuery(["referrals"], token, async (t) => {
    const res = await apiGet<{
      referralLink: string | null;
      referrals?: ReferralItem[];
      activePayingCount?: number;
      discountPercent?: number;
    }>("/referrals", t);
    if (!res.ok) throw new Error(getApiErrorMessage(res, "Referrals konnten nicht geladen werden"));
    return {
      referralLink: res.data.referralLink,
      referrals: res.data.referrals ?? [],
      activePayingCount: res.data.activePayingCount ?? 0,
      discountPercent: res.data.discountPercent ?? 0,
    } satisfies ReferralsData;
  });
}

export function useReferrals() {
  const { state } = useAuth();
  const token = state.status === "authenticated" ? state.token : null;
  return useQuery(referralsQueryOptions(token));
}
